import React from 'react'
// import PropTypes from 'prop-types'
import styled from 'styled-components';
import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #FFFFFF;
  padding: 1em;
  border-bottom: 1px solid #efefef;
  @media screen and (max-width: 500px) {
    width: max-content
  }
`
const OCTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  margin-bottom: .2em;
`
const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({margin}) => margin};
  width: ${({width}) => width};
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${({margin}) => margin};
  width: ${({width}) => width};
  @media screen and (max-width: 500px) {
    margin: ${({marginMobile}) => marginMobile};
  }
`
const DNIText = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #6A6A6A;
`
const ClockIcon = styled.img`
  height: 15px;
  width: 15px;
  margin-right: .5em;
`
const StoreIcon = styled.img`
  height: 12px;
  width: 14px;
  margin-right: .5em;
`
const DetailTxt = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: ${({color}) => color ? color : '#7C3F88'};
`
const PurchaseIcon = styled.img`
  height: 16px;
  width: 14px;
  margin-right: .5em;
`
const ChevronRight = styled.img`
  height: 32px;
  width: 32px;
  cursor: pointer;
`
// const StateContainer = styled.div`
//   border: 1px solid ${({colorBorder})=> colorBorder ? colorBorder : '#7C3F88'};
//   box-sizing: border-box;
//   background-color: ${({bgColor})=> bgColor ? bgColor : '#ffffff'};
//   border-radius: 24px;
//   padding: .4em 1em;
//   font-size: 12px;
//   line-height: 16px;
//   color: ${({colorTxt})=> colorTxt ? colorTxt : '#7C3F88'};
//   margin-left: 1em;
//   margin-right: ${({marginRight})=> marginRight ? marginRight : '0'};
// `
const PurpleCheckbox = withStyles({
  root: {
    color: '#CFD4D8',
    '&$checked': {
      color: '#5E388A',
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

const ItemPickingState = ({ row, rowIndex, onClickDetail, clientDni, orderNumber, purchaseDate, compromiseDate, storeName, cudsNumber, checked, onClickCheckBox, showCheckbox }) => {

  // const renderState = (state) => {
  //   switch (state) {
  //     case 'completed': return (
  //       <StateContainer marginRight='12px'>Completo</StateContainer>
  //     )
  //     case 'partial': return (
  //       <StateContainer colorTxt='#F15B5B' colorBorder='#F15B5B' marginRight='30px'>Parcial</StateContainer>
  //     )
  //     case 'rejected': return (
  //       <StateContainer colorTxt='#FFFFFF' colorBorder='#EE2737' bgColor='#EE2737' marginRight='7px'>Rechazado</StateContainer>
  //     )
  //     case 'pending': return (
  //       <StateContainer colorTxt='#999999' colorBorder='#999999' marginRight='10px'>Pendiente</StateContainer>
  //     )
  //     case 'assigned': return (
  //       <StateContainer colorTxt='#FFFFFF' colorBorder='#999999' bgColor='#999999' marginRight='15px'>Asignado</StateContainer>
  //     )

  //     default:
  //       break;
  //   }
  // }

  return (
    <Container>
      <RowDiv margin={!showCheckbox ? '0 0 0 1em' : null} marginMobile='0 1em 0 0'>
        { showCheckbox && <PurpleCheckbox checked={checked} onClick={() => onClickCheckBox(row, rowIndex)} />}
        <ColumnDiv>
          <RowDiv>
            <OCTxt>O. compra N° <span style={{fontWeight:500}}>{orderNumber}</span></OCTxt>
            {/* {renderState(state)} */}
            {/* <StateContainer>Completo</StateContainer> */}
          </RowDiv>
          <RowDiv>
            <DNIText>DNI del Cliente {clientDni}</DNIText>
          </RowDiv>
        </ColumnDiv>
      </RowDiv>
      <ColumnDiv marginMobile='0 1em 0 0' width='10em'>
        <RowDiv margin='0 0 .5em'>
          <PurchaseIcon src={require('../../../../assets/icons/ic_purchase.svg')} />
          <DetailTxt color='#F15B5B'><span style={{fontWeight:500}}>{cudsNumber}</span> CUDS</DetailTxt>
        </RowDiv>
        <RowDiv>
          {/* <PapperCheckIc src={require('../../../../assets/icons/ic_papper-check.svg')} /> */}
          <StoreIcon src={require('../../../../assets/icons/ic_store.svg')} />
          <DetailTxt>{storeName}</DetailTxt>
        </RowDiv>
      </ColumnDiv>
      <ColumnDiv marginMobile='0 1em 0 0'>
        <RowDiv margin='0 0 .5em'>
          <ClockIcon src={require('../../../../assets/icons/ic_clock.svg')} />
          <DetailTxt color='#70578B'>F. Venta: <span style={{fontWeight: 500}}>{moment.utc(purchaseDate).format('DD MMM YYYY')}</span></DetailTxt>
        </RowDiv>
        <RowDiv>
          <ClockIcon src={require('../../../../assets/icons/ic_clock.svg')} />
          <DetailTxt color='#70578B'>F. Despacho: <span style={{fontWeight: 500}}>{moment.utc(compromiseDate).format('DD MMM YYYY')}</span></DetailTxt>
        </RowDiv>
      </ColumnDiv>
      <RowDiv>
        <ChevronRight onClick={onClickDetail} src={require('../../../../assets/icons/ic_chevron-right_2.svg')}/>
      </RowDiv>
    </Container>
  )
}

export default ItemPickingState
